import React, { useEffect } from "react";
import { AppBar, Divider, Toolbar } from "@mui/material";
import { useFooterContext } from "../Constant";

const Footer = ({ children, sx }) => {
  const { setShowFooter } = useFooterContext();
  useEffect(() => {
    setShowFooter(true);
    return () => {
      setShowFooter(false);
    };
  }, [setShowFooter]);
  return (
    <AppBar
      elevation={0}
      component="nav"
      sx={{ background: "#FCFCFC", bottom: 0, top: "inherit", ...sx }}
    >
      <Divider />
      <Toolbar sx={{ justifyContent: "flex-end" }}>{children}</Toolbar>
    </AppBar>
  )
};

export default React.memo(Footer);
